import { render, staticRenderFns } from "./blogrolls.vue?vue&type=template&id=c92bb372&scoped=true&"
import script from "./blogrolls.vue?vue&type=script&lang=js&"
export * from "./blogrolls.vue?vue&type=script&lang=js&"
import style0 from "./blogrolls.vue?vue&type=style&index=0&id=c92bb372&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92bb372",
  null
  
)

export default component.exports